module.exports = __webpack_public_path__ + "assets/7d5da514eebbd934a052c841b5fd21a2.svg";